module.exports = __webpack_public_path__ + "static/media/home2.a8541dd3.jpg";